import axios from 'axios'

export default {
    download(filter) {
        return axios.download('/api/customerchains/export',
            {
                name: filter.text
            });
    },
    getCustomerChains(page, text) {
        return axios.get('/api/customerchains/table',
            {
                params: {
                    page: page,
                    name: text
                }
            });
    },
    getCustomerChain(id) {
        return axios.get(`/api/customerchains/table/${id}`);
    },
    saveCustomerChain(id, customerChain) {
        var request = Object.assign({}, customerChain);
        request.validationRules = customerChain.validationRules.map(r => r.value).join(',');
        if (id) {
            return axios.put(`/api/customerchains/${id}`, request);
        }
        return axios.post('/api/customerchains', request);
    },
    deleteCustomerChain(id) {
        return axios.delete(`/api/customerchains/${id}`);
    }
}



// WEBPACK FOOTER //
// ./ClientApp/app/masters/customerchains/api.js